import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import * as htmlToImage from 'html-to-image';
import download from 'downloadjs';
import {
  Container,
  Table,
  Button,
  Input,
  InputGroup,
  InputGroupText,
  Spinner,
} from 'reactstrap';
import "./AllVerifications.css";

const AllVerifications = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const qrRefs = useRef({});

  useEffect(() => {
    axios
      .get('https://app.rlagency.id/api_everification/get-all.php')
      .then((res) => {
        const result = res.data || [];
        setData(result);
        setFilteredData(result);
      })
      .catch(() => {
        setData([]);
        setFilteredData([]);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const term = searchTerm.toLowerCase();
    const filtered = data.filter(
      (item) =>
        item.name.toLowerCase().includes(term) ||
        item.event.toLowerCase().includes(term) ||
        item.serial_number.toLowerCase().includes(term)
    );
    setFilteredData(filtered);
  }, [searchTerm, data]);

  const handleDownload = (id, filename) => {
    const node = document.createElement('div');
    node.style.background = 'white';
    node.style.padding = '10px';
    node.style.display = 'inline-block';
  
    const qrCode = document.createElement('div');
    qrCode.setAttribute('id', `qr-${id}`);
    node.appendChild(qrCode);
  
    document.body.appendChild(node);
  
    import('react-dom/client').then((ReactDOMClient) => {
      const QRCode = require('react-qr-code').default;
      const root = ReactDOMClient.createRoot(qrCode);
  
      root.render(<QRCode value={`https://app.rlagency.id/verify/${id}`} size={500} />);
  
      setTimeout(() => {
        htmlToImage.toPng(node).then((dataUrl) => {
          download(dataUrl, filename);
          document.body.removeChild(node);
        });
      }, 300);
    });
  };  

  return (
    <Container>
      <h2 className="mb-4">Data Verifikasi QR</h2>

      <InputGroup className="mb-3">
        <InputGroupText>Cari</InputGroupText>
        <Input
          placeholder="Nama, Event, atau Serial Number"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </InputGroup>

      {loading ? (
        <div className="text-center">
          <Spinner color="primary" />
        </div>
      ) : (
        <div style={{ maxHeight: '80vh', overflowY: 'auto' }}>
          <Table bordered responsive hover className="applicants-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Nama</th>
                <th>Event</th>
                <th>Serial Number</th>
                <th>Link Verifikasi</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    Tidak ada data ditemukan.
                  </td>
                </tr>
              ) : (
                filteredData.map((item, index) => {
                  const filename = `${item.event}-${item.name}`.replace(/\s+/g, '_') + '.png';
                  const verifyUrl = `https://app.rlagency.id/verify/${item.serial_number}`;
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.event}</td>
                      <td>{item.serial_number}</td>
                      <td>
                        <a href={verifyUrl} target="_blank" rel="noreferrer">
                          {verifyUrl}
                        </a>
                      </td>
                      <td>
                        <Button
                          size="sm"
                          color="success"
                          onClick={() => handleDownload(item.serial_number, filename)}
                        >
                          Download PNG
                        </Button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>
      )}
    </Container>
  );
};

export default AllVerifications;